module.exports = __webpack_public_path__ + "img/团队名.37e33486.svg";